import { lazyLogSigsDatapoint } from 'owa-analytics';
import getImmutableEntryId from 'owa-immutable-id/lib/getImmutableEntryId';
import SigsInfo from '../store/schema/SigsInfo';

const sendPreviewedAttachmentSigs = async function (sigsInfo: SigsInfo) {
    if (sigsInfo) {
        const dwellTime = new Date().getTime() - sigsInfo.startTime;
        const immutableEntryId = sigsInfo.itemId && (await getImmutableEntryId(sigsInfo.itemId));
        lazyLogSigsDatapoint.importAndExecute('PreviewedAttachment', {
            itemId: immutableEntryId,
            customProperties: {
                FileId: sigsInfo.fileId,
                FileType: sigsInfo.fileType,
                DwellTime: dwellTime,
                Sender: sigsInfo.sender,
            },
        });
    }
};

export default sendPreviewedAttachmentSigs;
